import { apiRequest } from '../../services/apiClient';

// 회사소개 > 인증 페이지에 노출되는 인증서. 관리자 콘솔(/admin/certifications)에서 관리한다
export interface Certification {
  id: number;
  title: string;
  issuer: string;
  issuedDate: string | null;
  imageUrl: string;
  createdAt: string;
}

export interface AdminCertification extends Certification {
  sortOrder: number;
  isPublished: boolean;
}

export interface CertificationInput {
  title: string;
  issuer: string;
  issuedDate: string;
  isPublished: boolean;
}

export function fetchCertifications(): Promise<Certification[]> {
  return apiRequest<Certification[]>('/api/certifications');
}
